// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var Curry = require("rescript/lib/js/curry.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var RandomId$ReactHooksTemplate = require("./RandomId.res.js");
var CheckboxInput$ReactHooksTemplate = require("../common/CheckboxInput.res.js");
var MultipleSelect$ReactHooksTemplate = require("./MultipleSelect.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");

function MultipleSelectOptions(props) {
  var setErrorMessage = props.setErrorMessage;
  var onChange = props.onChange;
  var multipleSelect = props.multipleSelect;
  var choice = props.choice;
  var matchChoicesWithAnswer = function (choice) {
    var xs = MultipleSelect$ReactHooksTemplate.getAnswer(multipleSelect);
    if (xs !== undefined) {
      return Belt_List.has(xs, choice, (function (xs, ys) {
                    return Caml_obj.equal(MultipleSelect$ReactHooksTemplate.choiceId(xs), MultipleSelect$ReactHooksTemplate.choiceId(ys));
                  }));
    } else {
      return false;
    }
  };
  var reachedMax;
  if (MultipleSelect$ReactHooksTemplate.multipleAnswer(multipleSelect)) {
    var max = MultipleSelect$ReactHooksTemplate.maximumSelections(multipleSelect);
    reachedMax = max !== undefined && MultipleSelect$ReactHooksTemplate.answered(multipleSelect) ? max <= List.length(MultipleSelect$ReactHooksTemplate.answerIdList(multipleSelect)) : false;
  } else {
    reachedMax = false;
  }
  var isDisabled = reachedMax && !matchChoicesWithAnswer(choice);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(CheckboxInput$ReactHooksTemplate.make, {
                            checked: matchChoicesWithAnswer(choice),
                            disabled: isDisabled,
                            label: MultipleSelect$ReactHooksTemplate.getChoiceTextTranslation(multipleSelect, choice, SurveyLanguage$ReactHooksTemplate.name(props.language)),
                            handleChange: (function (param) {
                                var updatedMultipleSelect = MultipleSelect$ReactHooksTemplate.setAnswer(multipleSelect, choice);
                                var min = String(MultipleSelect$ReactHooksTemplate.minimumSelections(multipleSelect));
                                var max = MultipleSelect$ReactHooksTemplate.maximumSelections(multipleSelect);
                                var max$1 = max !== undefined ? String(max) : "";
                                var match = MultipleSelect$ReactHooksTemplate.getAnswer(updatedMultipleSelect);
                                var message = match !== undefined && !MultipleSelect$ReactHooksTemplate.isSelectionValid(updatedMultipleSelect) ? (
                                    max$1 === "" ? "Please select the minimum " + min + " options" : "Please select the minimum " + min + " and maximum " + max$1 + " number of options."
                                  ) : undefined;
                                Curry._1(setErrorMessage, (function (param) {
                                        return message;
                                      }));
                                Curry._1(onChange, updatedMultipleSelect);
                              }),
                            className: props.checkBoxInputClassName,
                            checkboxClassName: props.checkboxClassName
                          }),
                      className: props.containerClassName
                    }, RandomId$ReactHooksTemplate.toString(MultipleSelect$ReactHooksTemplate.choiceId(choice))),
                JsxRuntime.jsx("div", {
                      children: matchChoicesWithAnswer(choice) && MultipleSelect$ReactHooksTemplate.getAllowNonSpecifiedText(choice) ? JsxRuntime.jsx("textarea", {
                              className: props.textInputClassName,
                              placeholder: "Type here",
                              rows: 3,
                              onChange: (function (param) {
                                  return Curry._1(onChange, MultipleSelect$ReactHooksTemplate.setNotSpecifiedTextForAnswer(multipleSelect, MultipleSelect$ReactHooksTemplate.setNotSpecifiedText(Utils$ReactHooksTemplate.formTargetValue(param), choice)));
                                })
                            }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                    })
              ]
            });
}

var make = MultipleSelectOptions;

exports.make = make;
/* react/jsx-runtime Not a pure module */
